import { setSelectedInterest } from '../../utils/variables';

export function selectInterest(value) {
    removeAllSelectedInterest();

    setSelectedInterest(value);

    document
        .querySelector(
            `.interest__checkbox[data-interest="${CSS.escape(value)}"]`
        )
        .classList.add('is-selected');

    document
        .querySelector('.interestContinue__btn')
        .classList.remove('disabled');
}

export function removeAllSelectedInterest() {
    setSelectedInterest('');

    document
        .querySelectorAll('.interest__checkbox')
        .forEach((i) => i.classList.remove('is-selected'));

    document.querySelector('.interestContinue__btn').classList.add('disabled');
}
